import { assert_string_not_empty, assert_string_object_id, assert_type_enum, assert_type_string } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestWordsWithRelatedWordsCreate extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_WORD_WITH_RELATED_WORDS_CREATE;

  workspace_id!: string;
  language!: string;

  word_english!: string;
  word_translated!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
    assert_type_enum(this.language, ENUM__language_type);

    assert_string_not_empty(this.word_english);
    assert_type_string(this.word_translated);
  }
}
